module.exports = __webpack_public_path__ + "img/fwhip-0a6ee7ef-607d-4cee-d599-08d95d819f98.png";